import { render } from "./ExchangeCurrency.vue?vue&type=template&id=c1140896&scoped=true"
import script from "./ExchangeCurrency.vue?vue&type=script&lang=js"
export * from "./ExchangeCurrency.vue?vue&type=script&lang=js"

import "./ExchangeCurrency.vue?vue&type=style&index=0&id=c1140896&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1140896"]])

export default __exports__